
import { defineComponent } from "vue";
import GameService from "@/services/GameService";
import GameDetails from "@/_models/GameDetails";
import ResponseData from "@/_models/ResponseData";
import store from '@/store/index';
import { Helper } from "@/utils/Helper";

import Editor from "@tinymce/tinymce-vue";

export default defineComponent({
  props: ["gameData"],
  data: function () {
    return {
      details: {
        About: "",
      } as GameDetails,
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
    };
  },

  name: 'gamesTabGamePageAboutComponent',
  components: {
    editor: Editor,
  },
  methods: {
    updateAbout() {
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId.toString();
        let formData = new FormData();

        if (this.details.About !== "") {
          formData.append("About", this.details.About);
        }

        GameService.updateGameDetails(gameId, this.userData.userId, this.jwtToken, formData)
          .then((response: ResponseData) => {
            Helper.toastSuccessHandling(response.data['message']);
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    populateAboutDetails() {
      if (this.gameData.details) {
        this.details.About = this.gameData.details.about.about;
      }
    },
  },

  mounted() {
    this.populateAboutDetails();
  },
});
